module.exports = __webpack_public_path__ + "img/masterattender-locked.cc54f27e.png";